import { ArrayMaxSize, ArrayMinSize, IsArray } from 'class-validator';

export class OrderDownloadRequestDto {
  @IsArray()
  @ArrayMinSize(1)
  @ArrayMaxSize(500)
  orderNumbers: string[];

  @IsArray()
  @ArrayMinSize(1)
  @ArrayMaxSize(100)
  selectedFields: string[];
}
